import { useMemo } from "react";

import { CREATOR_COIN_TYPES } from "@/utils/constants";

interface CoinCategoryFormatterProps {
  coinCategory?: CREATOR_COIN_TYPES | string | null;
  className?: string;
}

const DEFAULT_COIN_CATEGORY = CREATOR_COIN_TYPES.creator;

const CoinCategoryFormatter = ({
  coinCategory,
  className = "",
}: CoinCategoryFormatterProps) => {
  const coinCategoryDisplayName = useMemo(() => {
    if (!coinCategory) {
      return DEFAULT_COIN_CATEGORY;
    }

    if (CREATOR_COIN_TYPES[coinCategory.toLowerCase() as CREATOR_COIN_TYPES]) {
      return coinCategory;
    } else {
      return coinCategory;
    }
  }, [coinCategory]);

  return <span className={className}>{coinCategoryDisplayName}</span>;
};

export { CoinCategoryFormatter };
